import { styled } from "@mui/material";
import { exProps } from "utils/mui";

export const InputComponent = styled('input')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSize,
  height: "1.9em",
  padding: 0,
  outline: "none",
  border: "none",
  background: "none",
  color: "white",
  boxSizing: "border-box",
  minWidth: 0,
  borderTop: `1px solid transparent`,
  borderBottom: `1px solid ${theme.palette.primary.main}`
}))

export const InputTypography = styled('div', exProps('empty'))<{ empty?: boolean }>
(({ theme, empty }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSize,
  height: "1.9em",
  lineHeight: "1.4em",
  paddingTop: "0.25em",
  paddingBottom: "0.25em",
  minWidth: 50,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  "&&": empty && {
    color: theme.palette.grey[600],
    userSelect: "none"
  }
}))